module.exports = __webpack_public_path__ + "static/media/06_hourglass.0288ec6e.png";


//////////////////
// WEBPACK FOOTER
// ../assets/icons/06_hourglass.png
// module id = 847
// module chunks = 0